import { render, staticRenderFns } from "./OrderSalesByCSR.vue?vue&type=template&id=2b464314&scoped=true&"
import script from "./OrderSalesByCSR.vue?vue&type=script&lang=js&"
export * from "./OrderSalesByCSR.vue?vue&type=script&lang=js&"
import style0 from "./OrderSalesByCSR.vue?vue&type=style&index=0&id=2b464314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b464314",
  null
  
)

export default component.exports